import React from 'react';
import { Alert, Button } from 'antd';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useIsOutletScoped } from '../../hooks/useIsOutletScoped';
import { useTranslation } from '../../hooks/useTranslation';

// Task 070-E — user quản lý outlet chỉ dùng được khu "Khách hàng" (chăm sóc khách + ticket). Mọi trang khác hiện lời giải thích thay vì lỗi 403 rời rạc;
// trang chủ tổ chức chuyển thẳng sang Khách hàng. Server (allowlist) mới là nơi chặn thật.
const OutletScopeGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const scoped = useIsOutletScoped();
  const { pathname } = useLocation();
  const { orgSlug } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!scoped) return <>{children}</>;
  const base = `/organizations/${orgSlug}`;
  const rel = pathname.slice(base.length).replace(/^\/+|\/+$/g, '');
  if (rel === '') return <Navigate to={`${base}/customers`} replace />;
  // customers (list, care, hồ sơ chỉ đọc /customers/:id/edit) và báo cáo voucher (đọc); chặn tạo khách + trang quản trị (loyalty-report/segments/campaigns).
  const allowed =
    rel === 'customers' ||
    rel === 'vouchers/usage' ||
    (rel.startsWith('customers/') && !/^customers\/(create|loyalty-report|loyalty-dashboard|crm-dashboard|segments|campaigns)(\/|$)/.test(rel));
  if (allowed) return <>{children}</>;
  return (
    <Alert
      style={{ margin: 24 }}
      type="warning"
      showIcon
      message={t('common.outletScopedTitle', { defaultValue: 'Tài khoản quản lý outlet không có quyền dùng chức năng này' })}
      description={t('common.outletScopedBody', { defaultValue: 'Bạn chỉ xem và chăm sóc khách hàng đã mua ở outlet của mình. Liên hệ quản trị tổ chức nếu cần thêm quyền.' })}
      action={<Button size="small" onClick={() => navigate(`${base}/customers`)}>{t('common.outletScopedBack', { defaultValue: 'Về Khách hàng' })}</Button>}
    />
  );
};

export default OutletScopeGate;
